import { createReducer } from '@reduxjs/toolkit'
import { DictT, RequestDesignT } from 'types/model'
import { receiveRequestsInProgress, clear, logout } from 'model/actions'

const initialState = {} as DictT<RequestDesignT>

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveRequestsInProgress, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
